(function () {
  function parseData() {
    var el = document.getElementById("echo-shop-data");
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || "{}") || {};
    } catch (e) {
      return {};
    }
  }

  function shadeKey(text) {
    var t = String(text || "").toLowerCase();
    if (t.indexOf("tender") !== -1) return "tender";
    if (t.indexOf("murmur") !== -1) return "murmur";
    if (t.indexOf("wander") !== -1) return "wander";
    if (t.indexOf("cassis") !== -1) return "cassis";
    if (t.indexOf("ochre") !== -1 || t.indexOf("orchre") !== -1) return "ochre";
    if (t.indexOf("oud") !== -1) return "oud";
    return "";
  }

  function firstAvailable(variants) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return i;
    }
    return 0;
  }

  function unwrapLookbookLinks() {
    document.querySelectorAll(".echo-lc .el-shades figure").forEach(function (fig) {
      fig.querySelectorAll("a.echo-look-link, a.echo-look-buy, a[href*='/products/']").forEach(function (a) {
        if (a.classList.contains("echo-add")) return;
        var parent = a.parentNode;
        while (a.firstChild) parent.insertBefore(a.firstChild, a);
        parent.removeChild(a);
      });
    });
  }

  function bindAjax(form, btn) {
    form.addEventListener("submit", function (evt) {
      evt.preventDefault();
      var fd = new FormData(form);
      if (btn) btn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        body: fd,
        headers: { Accept: "application/json" },
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw j;
            return j;
          });
        })
        .then(function () {
          if (typeof theme !== "undefined" && theme.Notify && theme.Notify.open) {
            theme.Notify.open("success", false, true);
          }
          var indicator = document.querySelector(".site-header__cart-indicator");
          if (indicator) indicator.classList.remove("hide");
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || "";
          if (msg && typeof theme !== "undefined" && theme.Notify && theme.Notify.open) {
            theme.Notify.open("error", msg, true);
          }
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    });
  }

  function mountShades(selector, data, addLabel, soldLabel, light) {
    document.querySelectorAll(selector).forEach(function (fig) {
      if (fig.querySelector(".echo-buybar")) return;
      var img = fig.querySelector("img");
      var capB = fig.querySelector("figcaption b, figcaption strong, span");
      var key =
        shadeKey((img && img.alt) || "") ||
        shadeKey((capB && capB.textContent) || "") ||
        shadeKey(fig.textContent || "");
      var item = key && data[key];
      var variants = (item && item.variants) || [];
      if (!variants.length) return;
      var caption = fig.querySelector("figcaption") || fig;

      var idx = firstAvailable(variants);
      var form = document.createElement("form");
      form.className = "echo-buybar" + (light ? " echo-buybar--light" : "");
      form.setAttribute("data-echo-add", "1");

      var sizes = document.createElement("div");
      sizes.className = "echo-sizes";
      sizes.setAttribute("role", "group");

      var hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = "id";
      hidden.value = String(variants[idx].id);

      var qty = document.createElement("input");
      qty.type = "hidden";
      qty.name = "quantity";
      qty.value = "1";

      var price = document.createElement("span");
      price.className = "echo-price";
      price.textContent = variants[idx].money || "";

      var btn = document.createElement("button");
      btn.type = "submit";
      btn.className = "echo-add";
      btn.textContent = variants[idx].available ? addLabel : soldLabel;

      function select(i) {
        idx = i;
        hidden.value = String(variants[i].id);
        price.textContent = variants[i].money || "";
        btn.disabled = !variants[i].available;
        btn.textContent = variants[i].available ? addLabel : soldLabel;
        sizes.querySelectorAll("button").forEach(function (b, n) {
          b.classList.toggle("is-active", n === i);
        });
      }

      variants.forEach(function (v, i) {
        var pill = document.createElement("button");
        pill.type = "button";
        pill.textContent = v.title;
        if (!v.available) pill.disabled = true;
        if (i === idx) pill.classList.add("is-active");
        pill.addEventListener("click", function () {
          if (v.available) select(i);
        });
        sizes.appendChild(pill);
      });

      form.appendChild(sizes);
      form.appendChild(hidden);
      form.appendChild(qty);
      form.appendChild(price);
      form.appendChild(btn);
      caption.appendChild(form);
      select(idx);
      bindAjax(form, btn);
    });
  }

  function mountKit(data, addLabel, soldLabel) {
    var card =
      document.querySelector(".echo-lc .el-shop .el-card") ||
      document.querySelector(".echo-lc .el-shop .echo-panel-x");
    if (!card || card.querySelector(".echo-kit-form")) return;
    var kit = data.kit || {};
    var variants = kit.variants || [];
    if (!variants.length) return;
    var v = variants[firstAvailable(variants)] || variants[0];

    var actions = card.querySelector(".el-reserve-actions, .echo-actions-x");
    if (actions) actions.remove();

    var priceB = card.querySelector(".el-price b, .echo-cost-x b");
    if (priceB && v.money) priceB.textContent = v.money;

    var form = document.createElement("form");
    form.className = "echo-kit-form";
    form.setAttribute("data-echo-add", "1");
    form.innerHTML =
      '<div class="el-qty">' +
      '<button type="button" data-qty-minus aria-label="-">−</button>' +
      '<input type="number" name="quantity" min="1" value="1">' +
      '<button type="button" data-qty-plus aria-label="+">+</button>' +
      "</div>" +
      '<input type="hidden" name="id" value="' +
      String(v.id) +
      '">' +
      '<button type="submit" class="el-submit">' +
      (v.available ? addLabel : soldLabel) +
      "</button>";

    var qtyWrap = form.querySelector(".el-qty");
    var input = form.querySelector('input[name="quantity"]');
    function clamp(n) {
      n = parseInt(n, 10);
      if (isNaN(n) || n < 1) n = 1;
      return n;
    }
    qtyWrap.querySelector("[data-qty-minus]").addEventListener("click", function () {
      input.value = String(clamp((parseInt(input.value, 10) || 1) - 1));
    });
    qtyWrap.querySelector("[data-qty-plus]").addEventListener("click", function () {
      input.value = String(clamp((parseInt(input.value, 10) || 1) + 1));
    });
    input.addEventListener("change", function () {
      input.value = String(clamp(input.value));
    });

    var btn = form.querySelector(".el-submit");
    btn.disabled = !v.available;
    var priceBlock = card.querySelector(".el-price, .echo-cost-x");
    if (priceBlock && priceBlock.nextSibling) {
      card.insertBefore(form, priceBlock.nextSibling);
    } else {
      card.appendChild(form);
    }
    bindAjax(form, btn);
  }

  function variantByMl(item, ml) {
    var vs = (item && item.variants) || [];
    var needle = String(ml);
    for (var i = 0; i < vs.length; i++) {
      if (String(vs[i].title).indexOf(needle) !== -1) return vs[i];
    }
    return vs[0] || null;
  }

  function mountSizeFormats(data, addLabel, soldLabel) {
    [
      { sel: ".echo-lc .el-size-15", ml: "15" },
      { sel: ".echo-lc .el-size-9", ml: "9" },
    ].forEach(function (slot) {
      var fig = document.querySelector(slot.sel);
      if (!fig || fig.querySelector(".echo-buybar")) return;
      var shades = ["tender", "murmur", "wander", "cassis", "ochre", "oud"];
      var current = "";
      for (var s = 0; s < shades.length; s++) {
        var v0 = variantByMl(data[shades[s]], slot.ml);
        if (v0 && v0.available) {
          current = shades[s];
          break;
        }
      }
      if (!current) current = shades[0];

      var form = document.createElement("form");
      form.className = "echo-buybar echo-buybar--light";
      form.setAttribute("data-echo-add", "1");

      var sizes = document.createElement("div");
      sizes.className = "echo-sizes echo-sizes--shades";
      sizes.setAttribute("role", "group");

      var hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = "id";

      var qty = document.createElement("input");
      qty.type = "hidden";
      qty.name = "quantity";
      qty.value = "1";

      var price = document.createElement("span");
      price.className = "echo-price";

      var btn = document.createElement("button");
      btn.type = "submit";
      btn.className = "echo-add";

      function select(key) {
        current = key;
        var v = variantByMl(data[key], slot.ml);
        if (!v) return;
        hidden.value = String(v.id);
        price.textContent = v.money || "";
        btn.disabled = !v.available;
        btn.textContent = v.available ? addLabel : soldLabel;
        sizes.querySelectorAll("button").forEach(function (b) {
          b.classList.toggle("is-active", b.getAttribute("data-shade") === key);
        });
      }

      shades.forEach(function (key) {
        var v = variantByMl(data[key], slot.ml);
        if (!v) return;
        var pill = document.createElement("button");
        pill.type = "button";
        pill.setAttribute("data-shade", key);
        pill.textContent = key.charAt(0).toUpperCase() + key.slice(1);
        if (!v.available) pill.disabled = true;
        if (key === current) pill.classList.add("is-active");
        pill.addEventListener("click", function () {
          if (v.available) select(key);
        });
        sizes.appendChild(pill);
      });

      form.appendChild(sizes);
      form.appendChild(hidden);
      form.appendChild(qty);
      form.appendChild(price);
      form.appendChild(btn);
      fig.appendChild(form);
      select(current);
      bindAjax(form, btn);
    });
  }

  var LABELS = {
    pl: { add: "Dodaj do koszyka", sold: "Wyprzedane" },
    en: { add: "Add to cart", sold: "Sold out" },
    ua: { add: "Додати до кошика", sold: "Розпродано" },
  };

  function applyEchoLabels(lang) {
    var pack = LABELS[lang] || LABELS.pl;
    document.querySelectorAll(".echo-buybar .echo-add, .echo-kit-form .el-submit").forEach(function (btn) {
      if (btn.disabled) btn.textContent = pack.sold;
      else btn.textContent = pack.add;
    });
  }

  function boot() {
    var page = document.querySelector("[data-echo-shop]");
    var addLabel = (page && page.getAttribute("data-add-label")) || "Dodaj do koszyka";
    var soldLabel = (page && page.getAttribute("data-sold-label")) || "Wyprzedane";
    var data = parseData();
    unwrapLookbookLinks();
    mountShades(".echo-lc .el-shades figure", data, addLabel, soldLabel, false);
    mountShades(".echo-lc .el-bottles figure", data, addLabel, soldLabel, true);
    mountSizeFormats(data, addLabel, soldLabel);
    mountKit(data, addLabel, soldLabel);
    document.querySelectorAll(".echo-lc .el-lang button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var lang = (btn.textContent || "").trim().toLowerCase();
        if (lang === "ua" || lang === "uk") lang = "ua";
        applyEchoLabels(lang);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
